const MASCOTE_NOTEBOOK = "/assets/space/mascote-space-notebook.png";
const MASCOTE_TCHAU = "/assets/space/mascote_space_tchau.png";

type AstronautPortholeProps = {
	readonly sourcePage: "401" | "404";
};

export default function AstronautPorthole({ sourcePage }: AstronautPortholeProps) {
	const mascoteSelecionado = sourcePage === "401" ? MASCOTE_NOTEBOOK : MASCOTE_TCHAU;

	return (
		<div className="relative flex items-center justify-center">
			<div className="relative flex aspect-square w-full max-w-[180px] items-center justify-center sm:max-w-[280px] lg:max-w-[460px]">
				{/* Disco / planeta */}
				<div className="absolute inset-[20px] overflow-hidden rounded-full bg-[radial-gradient(circle_at_35%_30%,#3a1450,#1a0a2e_60%,#0a0518)] shadow-[inset_0_0_60px_rgba(0,0,0,0.6),0_0_80px_rgba(122,27,90,0.4)]">
					<div className="absolute -top-[40%] -left-[20%] h-[60%] w-[160%] bg-[radial-gradient(ellipse_at_center,rgba(236,72,153,0.5),transparent_70%)]" />
				</div>

				{/* Órbita interna */}
				<div className="absolute inset-0 animate-[scSpin_28s_linear_infinite] rounded-full border border-dashed border-white/20">
					<span className="absolute -top-1.5 left-1/2 h-3.5 w-3.5 -translate-x-1/2 rounded-full bg-[#38E1FF] shadow-[0_0_16px_3px_rgba(56,225,255,0.8)]" />
				</div>

				{/* Órbita externa */}
				<div className="absolute -inset-6 animate-[scSpinRev_44s_linear_infinite] rounded-full border border-white/10">
					<span className="absolute -bottom-1 left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-white shadow-[0_0_10px_2px_rgba(255,255,255,0.7)]" />
				</div>

				{/* Mascote */}
				<img
					src={mascoteSelecionado}
					alt="Mascote SPACE"
					className="relative z-10 h-[250px] w-auto animate-[scFloatSlow_5.5s_ease-in-out_infinite] drop-shadow-[0_22px_30px_rgba(0,0,0,0.6)] sm:h-[340px] lg:h-[540px]"
				/>
			</div>
		</div>
	);
}
